import { type FC } from 'react';
import { Global } from '@emotion/react';
import manifapro3Light from '~/foundation/Assets/fonts/UXUS_ManifaPro3_v3.3/ManifaPro3-Light.woff2';
import manifapro3Bold from '~/foundation/Assets/fonts/UXUS_ManifaPro3_v3.3/ManifaPro3-SemiBold.woff2';
import ghawarSemiBold from '~/foundation/Assets/fonts/ghawar/ghawar-semibold-v1.woff2';
import ghawarRegular from '~/foundation/Assets/fonts/ghawar/ghawar-regular.woff2';
import ghawarLight from '~/foundation/Assets/fonts/ghawar/Ghawar-Light.woff2';
import haradhBold from '~/foundation/Assets/fonts/Haradh/Haradh_V1.344-Beta_4.0-Bold.woff2';
import haradhRegular from '~/foundation/Assets/fonts/Haradh/Haradh_V1.344-Beta_4.0-Regular.woff2';
import config from "~/temp/config";

type FontsProps = {
	rtl: boolean;
	siteLanguage?: string;
}

const Fonts: FC<FontsProps> = ({ rtl }) => {
	// the server bundle loads base64 while the client loads files
	if (!config.connected && typeof window !== "undefined") {
		return <></>;
	}

	let fontStyle = `
	marquee {
		font-family: verdana;
	}

	@font-face {
		font-family: "ManifaPro3";
		src: url("${manifapro3Bold}") format("woff2");
		font-weight: 900;
		font-style: normal;
		font-display: swap;
	}
	@font-face {
		font-family: "ManifaPro3";
		src: url("${manifapro3Light}") format("woff2");
		font-weight: 300;
		font-style: normal;
		font-display: swap;
	}`;

	if (rtl) {
		fontStyle += `
		@font-face {
			font-family: "Haradh";
			src: url("${haradhBold}") format("woff2");
			font-weight: 600;
			font-style: normal;
			font-display: swap;
		}
		@font-face {
			font-family: "Haradh";
			src: url("${haradhRegular}") format("woff2");
			font-weight: 400;
			font-style: normal;
			font-display: swap;
		}`;
	} else {
		fontStyle += `
		@font-face {
			font-family: "Ghawar";
			src: url("${ghawarSemiBold}") format("woff2");
			font-weight: 600;
			font-style: normal;
			font-display: swap;
		}
		@font-face {
			font-family: "Ghawar";
			src: url("${ghawarRegular}") format("woff2");
			font-weight: 400;
			font-style: normal;
			font-display: swap;
		}
		@font-face {
			font-family: "Ghawar";
			src: url("${ghawarLight}") format("woff2");
			font-weight: 300;
			font-style: normal;
			font-display: swap;
		}`;
	}

	//example for japanese which uses other fonts
	// if (siteLanguage === "ja-JP" || siteLanguage === "ja-jp"){
	// 	return <></>;
	// }

	return (
		<Global styles={fontStyle} />
	);
}

Fonts.displayName = "Fonts";

export default Fonts;